// src/components/footer/footer.js
import React from 'react';
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from 'react-icons/fa';
import { FiX } from 'react-icons/fi';
import './footer.css';

const Footer = () => {
  return (
    <footer className="footer-container">
      <div className="footer-overlay">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img 
                src="/images/LOGO-ETEF-DESIGN.jpg" 
                alt="ETEF DESIGN" 
                className="footer-logo-image"
              />
              <p>« La satisfaction du client, notre première source de motivation ! »</p>
            </div>
            <div className="social-icons">
              <h3>Suivez-nous</h3>
              <div className="icons">
                <a href="#"><FaFacebook className="icon" /></a>
                <a href="#"><FaInstagram className="icon" /></a>
                <a href="#"><FiX className="icon" /></a>
                <a href="#"><FaYoutube className="icon" /></a>
              </div>
            </div>
          </div>

          <div className="footer-section">
            <h3>PLAN DU SITE</h3>
            <ul>
              <li>Accueil</li>
              <li>Nos Services</li>
              <li>Nos Offres</li>
              <li>La Société</li>
              <li>Contact</li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>NOS SERVICES</h3>
            <ul>
              <li>DEVELOPPEMENT WEB</li>
              <li>REFONTE DE SITE WEB</li>
              <li>REFERENCEMENT WEB</li>
              <li>DESIGN NUMERIQUE</li>
              <li>DEVELOPPEMENT MOBILE</li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact</h3>
            <ul>
              <li>Email : design.pro@etef.fr</li>
              <li>Adresse : Hôtel des Postes, 13001 Marseille, France</li>
              <li>Téléphone : +(33) 6 95 74 40 27</li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>Copyright © 2025 | Tous droits réservés. ETEF DESIGN</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;